/* import __COLOCATED_TEMPLATE__ from './market-input-common-money.hbs'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { set, action } from '@ember/object';
import { Money } from '@square/dashboard-protos/models/squareup/common/currency';
import { CurrencyCode } from '@square/dashboard-protos/models/squareup/common/currency_codes';

/*
 *
 * Most of this was copied from Transfers::MoneyInput, and updated
 * to work with market-input-text and the common Money proto
 *
 */

function commaSeparated(str) {
  // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
function formatMoney(money) {
  const hasCents = money.amount % 100 !== 0; // we'll only display cents if they're not .00
  const dollars = (money.amount / 100).toFixed(hasCents ? 2 : 0);
  return `$${commaSeparated(dollars)}`;
}
function parseMoney(formattedAmount) {
  const parts = formattedAmount.replace(/[$,]/g, '').split('.');
  const dollars = parts[0] || '0';
  let cents = parts[1] || '00';
  if (cents.length === 1) {
    // they typed .1 and they want 10 cents:
    cents += '0';
  }
  const amount = Number.parseInt(dollars, 10) * 100 + (Number.parseInt(cents, 10) || 0);
  return new Money.Builder().amount(amount).currencyCode(CurrencyCode.USD).build();
}
let MarketInputCommonMoney = (_class = class MarketInputCommonMoney extends Component {
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "maxDollars", 999999);
    _defineProperty(this, "input", void 0);
    // Internal state we'll modify on input.
    // NOTE: this component, for better or worse, operates textually by editing this string:
    _defineProperty(this, "formattedAmount", '');
    // Flags if input was typed in (as opposed to input field being directly manipulated)
    _defineProperty(this, "isKeyedIn", false);
    const currentAmount = parseMoney(this.formattedAmount).amount;
    if (this.args.money && this.args.money.amount !== undefined && this.args.money.amount !== currentAmount) {
      set(this, 'formattedAmount', formatMoney(this.args.money));
    }
  }
  applyBackspace() {
    // If you're trying to delete
    if (this.formattedAmount.length > 1 && this.formattedAmount !== '$0') {
      // Let you delete anything up until the last character, that should always be a $
      const parts = [...this.formattedAmount];
      parts.pop();
      // Get rid of any commas and reformat as needed
      let newNumber = parts.filter(d => d !== ',').join('');
      // If we deleted everything, set to 0
      if (newNumber === '$') {
        newNumber = '';
      }
      set(this, 'formattedAmount', commaSeparated(newNumber));
    }
  }
  applyNumber(numberKey) {
    const periodIndex = this.formattedAmount.indexOf('.');
    if (periodIndex < 0) {
      // If there's no period, we're typing dollars
      this.applyDollars(numberKey);
    } else if (periodIndex > this.formattedAmount.length - 3) {
      // Otherwise we're typing cents
      // If there's still room for more cents, add the requested cent:
      set(this, 'formattedAmount', this.formattedAmount + numberKey);
    }
  }
  applyDollars(numberKey) {
    // Transform to just numbers (note that applyNumber enforces that there are no cents inside this function)
    const dollarString = this.formattedAmount.replace(/[$,]/g, '');
    // Apply new digit and parse to a Number to strip leading 0:
    const newNumber = Number(dollarString + numberKey);
    if (newNumber > this.maxDollars) {
      // If the new number is too large reject the change.
      return;
    }

    // Comma separate and restore dollar sign:
    set(this, 'formattedAmount', `$${commaSeparated(newNumber.toString())}`);
  }
  applyPeriod() {
    // If you're trying to add cents
    if (this.formattedAmount.length > 1 && !this.formattedAmount.includes('.')) {
      // If you don't already have cents, and you're not just a '$'
      set(this, 'formattedAmount', `${this.formattedAmount}.`);
    }
  }
  registerInput(element) {
    set(this, 'input', element);
  }

  // Called during typical interactions (i.e. user input from keyboard)
  handleKeyDown(event) {
    try {
      if (event.key === 'Backspace') {
        this.applyBackspace();
      } else if (/\d/.test(event.key)) {
        this.applyNumber(event.key);
      } else if (event.key === '.') {
        this.applyPeriod();
      } else if (event.key === 'Tab' || event.key === 'Enter') {
        // Allow tabbing to the submit button, or submitting with Enter
        return;
      } else if (event.ctrlKey || event.metaKey) {
        // Capture paste actions and allow them to be handled by handlePaste()
        return;
      } else if (event.key === 'Unidentified') {
        // Android web bug where some key events are 'Unidentified'.
        // Since we're using a decimal keyboard let's assume it's a period.
        this.applyPeriod();
      }
      // TODO: do we want to handle copy-paste here?
    } catch {
      // TODO: sentry?
    }

    // Throw away event, since we should have applied all valid inputs above
    event.preventDefault();

    // ember-test-helpers has a bug where it doesn't acknowledge preventDefault()
    // so set this flag here so we know how to fix things up in handleChange()
    // https://github.com/emberjs/ember-test-helpers/issues/912
    this.isKeyedIn = true;
    if (this.args.onChange) {
      this.args.onChange(parseMoney(this.formattedAmount));
    }
  }

  // Called when the user attempts to paste into the amount
  handlePaste(event) {
    event.preventDefault();
    const pasteText = event.clipboardData?.getData('Text');

    // Only allows numerical values to be paste in
    if (pasteText && /[\d$]/.test(pasteText)) {
      const money = parseMoney(pasteText);

      // Only allow paste functionality for valid entries
      if (!Number.isNaN(money.amount)) {
        set(this, 'formattedAmount', formatMoney(money));
      }
    }
    if (this.args.onChange) {
      this.args.onChange(parseMoney(this.formattedAmount));
    }
  }

  // Compensate for bug where ember-test-helpers doesn't respect preventDefault()
  // by syncing the displayed input field value and the internal value
  handleChange(event) {
    const target = event.target;
    if (target.value === this.formattedAmount) {
      // Already in sync, nothing to fix here
      return;
    }
    if (this.isKeyedIn) {
      // Typing happened, so we've been building the value internally with each keystroke
      // internal value is the source of truth
      target.value = this.formattedAmount;
    } else {
      // No typing happened, meaning input field was manipulated directly
      // the displayed input field value is the source of truth
      const money = parseMoney(target.value);
      set(this, 'formattedAmount', formatMoney(money));
      if (this.args.onChange) {
        this.args.onChange(money);
      }
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "registerInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handlePaste", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handlePaste"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleChange"), _class.prototype), _class);
export { MarketInputCommonMoney as default };